module.exports = __webpack_public_path__ + "static/media/Satv_why.94adea7c.mp3";